/** Open the existing proposal flow, retaining its subscription checks and format options. */
export const requestProposalExport = (): void => {
  window.dispatchEvent(new globalThis.CustomEvent('trigger_export_proposal', {
    detail: { stayOnOverview: true },
  }));
};
